export default {
  'PerceptualMappingChart.title': 'Perceptual Mapping',
  'PerceptualMappingChart.noTopics': 'Choose 2 topics from list',
  'PerceptualMappingChart.good': 'Good',
  'PerceptualMappingChart.bad': 'Bad',
  'PerceptualMappingChart.neutral': 'Neutral',
}
